<template>
  <div class="data-table-file-explorer">
    <q-table
      class="data-table-file-explorer__table scroll"
      flat
      :columns="columns"
      :pagination.sync="pagination"
      :data="rows"
      no-data-label="No Data"
      style="height: 100%"
      :loading="visible"
      :visible-columns="visibleColumns"
      :filter="filter"
      color="secondary"
      ><template v-slot:loading>
        <q-inner-loading showing color="secondary" />
      </template>
      <template v-slot:top>
        <div class="data-table-file-explorer__top">
          <div class="data-table-file-explorer__title">
            {{ title }}
          </div>
          <q-input
            rounded
            outlined
            dense
            color="secondary"
            debounce="300"
            v-model="filter"
            placeholder="Search"
            class="data-table-file-explorer__search"
          >
            <template v-slot:append>
              <q-icon name="search" color="secondary" />
            </template>
          </q-input>
        </div>
      </template>
      <template v-slot:header="props">
        <q-tr
          :props="props"
          class="data-table-file-explorer__header"
          style="height: 34px"
        >
          <!-- <q-th v-for="col in props.cols" :key="col.name" :props="props">
            <span v-if="col.label === 'ext'"></span>
            <span v-if="col.label === 'name'">File</span>
            <span v-if="col.label === 'size'">Size</span>
            <span v-if="col.label === 'updated_at'">Modified</span>
          </q-th> -->
          <q-th key="name" :props="props"> File </q-th>
          <q-th key="size" :props="props" v-if="$q.screen.gt.xs"> Size </q-th>
          <q-th key="updated_at" :props="props" v-if="$q.screen.gt.xs">
            Modified
          </q-th>
          <q-th key="updated_at" :props="props" v-else />
        </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props" class="data-table-file-explorer__row">
          <q-td key="name" :props="props">
            <q-icon
              class="icon"
              v-if="props.row.ext === '.docx'"
              :name="'img:' + imageWord"
            />
            <q-icon
              class="icon"
              v-else-if="props.row.ext === '.xlsx'"
              :name="'img:' + imageExcel"
            />
            <q-icon
              class="icon"
              v-else-if="props.row.ext === '.csv'"
              :name="'img:' + imageExcel"
            />
            <q-icon
              class="icon"
              v-else-if="props.row.ext === '.pptx'"
              :name="'img:' + imagePowerPoint"
            />
            <q-icon
              class="icon"
              v-else-if="props.row.ext === '.pdf'"
              :name="'img:' + imagePDF"
            />
            <q-icon
              class="image"
              v-else-if="props.row.ext === '.png' || '.jpg'"
              :name="'img:' + props.row.url"
            />
            <q-icon class="image" v-else :name="'img:' + imageDefault" />

            <span class="q-ml-md file-column" v-if="props.row.caption">{{
              props.row.caption
            }}</span>
            <span class="q-ml-md file-column" v-else>{{ props.row.name }}</span>
          </q-td>
          <q-td
            key="size"
            class="size-column"
            :props="props"
            v-if="$q.screen.gt.xs"
          >
            {{ formatSize(props.row.size) }}
          </q-td>
          <q-td key="updated_at" :props="props" class="modified-column">
            <div class="data-table-file-explorer__cell-flex">
              <span v-if="$q.screen.gt.xs">{{
                formatDateTime(props.row.updatedAt)
              }}</span>

              <a
                :href="props.row.url"
                target="_blank"
                download
                style="text-decoration: none"
              >
                <q-icon
                  style="font-size: 2em"
                  name="file_download"
                  color="secondary"
                />
              </a>
            </div>
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import imageDefault from "@/assets/file-types/default.svg";
import imageWord from "@/assets/file-types/word.svg";
import imagePDF from "@/assets/file-types/pdf.svg";
import imageExcel from "@/assets/file-types/excel.svg";
import imagePowerPoint from "@/assets/file-types/pptx.svg";
import { formatDateTime } from "@/utils/formatDate";
import { formatSize } from "@/utils/formatNumbers";
export default {
  props: {
    title: String,
    dataset: String,
    timer: Number,
  },
  data() {
    return {
      imageDefault: imageDefault,
      imageWord: imageWord,
      imagePDF: imagePDF,
      imageExcel: imageExcel,
      imagePowerPoint: imagePowerPoint,
      filter: "",
      pagination: {
        page: 1,
        rowsPerPage: 10,
      },
      visibleColumns: ["name", "caption", "size", "updated_at"],
      columns: [],
      keys: [],
      rows: [],
      errors: [],
      interval: null,
      dataRefresh: this.$props.timer,
      visible: false,
    };
  },
  computed: {
    numberOfPages() {
      // calculate pagination
      return Math.ceil(this.rows.length / this.pagination.rowsPerPage);
    },
  },
  methods: {
    formatDateTime,
    formatSize,
    async fetchDocuments() {
      // Dataset name is the store procedure name used to return the results.
      const payload = {
        link: this.$props.dataset,
      };

      await this.$store
        .dispatch("fetchAllDocumentItems", payload)
        .then((response) => {
          // Check response for "Files"
          if (response.data.Files !== undefined) {
            // List attritbutes of the object we want
            this.columns = [
              "ext",
              "url",
              "name",
              "caption",
              "size",
              "updated_at",
            ].map((columnName) => ({
              name: columnName,
              label: columnName,
              field: columnName,
              sortable: true,
              align: "left",
            }));
          }
          this.rows = response.data.Files;
          this.visible = false;
        })
        .catch((error) => {
          this.errors.push(error);
        });

      console.log("this.rows....", this.rows);
    },
  },
  mounted() {
    this.fetchDocuments();
  },

  beforeDestroy: function () {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
.data-table-file-explorer {
  &__table {
    .q-table__top {
      border-bottom: 1px solid #e0e0e0;
    }
  }
  &__top {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    @media only screen and (min-width: 500px) {
      height: 50px;
      justify-content: space-between;
      flex-direction: row;
    }
  }
  &__title {
    font-family: Barlow;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    margin-right: 1em;
    color: #13110c;
  }
  &__header {
    th {
      font-weight: 600;
    }
  }
  &__row {
    height: 80px !important;
    padding: 0 10px;
    border-bottom: 1px solid #ebeff2;
    &:last-of-type {
      border-bottom: none;
    }
    .image {
      height: 40px;
      width: 40px;
      border-radius: 10px;
      object-fit: cover;
    }
    .icon {
      font-size: 3em;
    }
    .file-column {
      font-weight: 600;
      font-size: 12px;
      line-height: 1;
      color: #13110c;
      max-width: 136px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      @media only screen and (min-width: 360px) {
        max-width: 180px;
      }
      @media only screen and (min-width: 450px) {
        max-width: 250px;
      }
      @media only screen and (min-width: 500px) {
        max-width: 100%;
      }
    }
    .size-column {
      width: 100px;
      font-weight: 600;
      font-size: 12px;
      color: rgba(39, 48, 67, 0.5);
    }
    .modified-column {
      width: 56px;
      font-weight: 600;
      font-size: 12px;
      color: rgba(39, 48, 67, 0.5);
      @media only screen and (min-width: 600px) {
        width: 180px;
      }
    }
  }
  &__cell-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.body {
  &--dark {
    .data-table-file-explorer {
      &__table {
        .q-table__top {
          border-bottom: 1px solid #353535;
        }
      }
      &__title {
        color: #fff;
      }

      &__row {
        border-bottom: 1px solid #353535;
        &:last-of-type {
          border-bottom: none;
        }

        .file-column {
          color: #fff;
        }
        .size-column {
          color: #adadad;
        }
        .modified-column {
          color: #adadad;
        }
      }
    }
  }
}
</style>
